// Deliberately fixed presentation examples, never written into orders or payments.
export function chartExamples(collections = []) {
  const examples = [
    ["INDRA", 35],
    ["ARANYA", 25],
    ["SUTRA", 20],
    ["KALA", 12],
    ["VEDA", 4],
    ["AADIVASI", 2],
    ["BHOOMI", 2],
  ];
  const base = examples.map(([name, percent]) => ({ name, percent }));
  const names = new Set(examples.map(([name]) => name));
  return [
    ...base,
    ...collections
      .filter(
        (c) =>
          !names.has(String(c.code || "").toUpperCase()) &&
          !names.has(String(c.name || "").toUpperCase()),
      )
      .map((c) => ({ name: c.name, percent: 0 })),
  ];
}
